import React, { useState } from 'react';
import { Input, Modal, message } from 'antd';
import { submitProviderFeedback } from 'api/provider';
import s from './s.module.less';

type Props = {
    open: boolean;
    onClose: () => void;
};

// 服务端 value 上限 4096（超长返 91047 不截断），输入框直接封顶
const MAX_LEN = 4096;

// dashboard 底部「Share feedback」弹窗：beta 期收集 provider 建议（POST /provider/feedback）
const FeedbackModal = ({ open, onClose }: Props) => {
    const [text, setText] = useState('');
    const [submitting, setSubmitting] = useState(false);

    const handleSubmit = async () => {
        const value = text.trim();
        if (!value || submitting) return;
        setSubmitting(true);
        try {
            const res: any = await submitProviderFeedback({
                type: 'INSURANCE_BILLING_SUGGESTION',
                value,
                metaData: '{"page":"insurance-billing-dashboard"}',
            });
            if (!res?.error) {
                message.success('Thanks, we got it! Every suggestion is read.');
                setText('');
                onClose();
            }
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <Modal
            open={open}
            title="Share your suggestions"
            okText="Submit suggestion"
            cancelText="Cancel"
            okButtonProps={{ disabled: !text.trim() }}
            confirmLoading={submitting}
            onOk={handleSubmit}
            onCancel={onClose}
            width={520}
        >
            <p className={s.feedbackIntro}>
                Managed billing is in beta, and what you tell us here shapes what we build next.
            </p>
            <Input.TextArea
                rows={5}
                maxLength={MAX_LEN}
                placeholder="What would make Managed billing work better for you?"
                value={text}
                onChange={(e) => setText(e.target.value)}
            />
        </Modal>
    );
};

export default FeedbackModal;
